import Immutable from 'immutable';

const linksConfig = Immutable.fromJS([
    {
        linkKey: 'home',
        to: '/',
        text: 'Home',
        icon: 'home'
    }, {
        linkKey: 'workOrderSearch',
        to: '/work-order-search',
        text: 'Order Search',
        icon: 'search'
    }, {
        linkKey: 'workOrderDetail',
        to: '/work-order-detail',
        text: 'Work Order Detail',
        icon: 'glyphicon-pencil'
    }, {
        linkKey: 'inventory',
        to: '/inventory',
        text: 'Inventory',
        icon: 'router'
    }, {
        linkKey: 'messages',
        to: '/messages',
        text: 'Messages',
        icon: 'email'
    }, {
        linkKey: 'techAlert',
        to: '/techAlert',
        text: 'Tech Alerts',
        icon: 'glyphicon-flash'
    }, {
        linkKey: 'emergency',
        to: '/emergency',
        text: 'Emergency',
        icon: 'warning'
    }, {
        linkKey: 'techSearch',
        to: '/tech-search',
        text: 'Tech Search',
        icon: 'search'
    }, {
        linkKey: 'techHistorySearch',
        to: '/tech-history-search',
        text: 'Tech Order History',
        icon: 'search'
    }, {
        linkKey: 'settings',
        to: '/settings',
        text: 'Settings',
        icon: 'settings'
    }, {
        linkKey: 'myRoute',
        to: '/my-route',
        text: 'Route',
        icon: 'directions_car'
    }, {
        linkKey: 'equipmentSearch',
        to: '/equipment-search',
        text: 'Equipment Search',
        icon: 'search'
    }, {
        linkKey: 'equipmentTransfer',
        to: '/equipment-transfer',
        text: 'Equipment Transfer',
        icon: 'swap_horiz'
    },
    {
        linkKey: 'workOrderTransfer',
        to: '/work-order-transfer',
        text: 'Work Order Transfer',
        icon: 'swap_horiz'
    }

]);

export default linksConfig;


// WEBPACK FOOTER //
// ./src/constants/linksConfig.js